export const TRANSLATION_GROUP_MIRRORS_CREATE_FILE = Symbol('admin.mirrors-list.create-file');

export const MIRRORS_LIST_CREATE_FILE_JS_ROUTE_NAME = Symbol('admin.mirrors-list.create-file-js');
export const MIRRORS_LIST_CREATE_FILE_NO_JS_ROUTE_NAME = Symbol('admin.mirrors-list.create-file-no-js');

export const MIRROR_CREATE_FILE_MUTATION_KEY = 'mirror-create-file-mutation-key';
export const MIRROR_CREATE_FILE_MUTATION_API_URL = 'admin/mirrors/create_with_file';
